import { Navigate } from 'react-router-dom';

export function Organization() {
  return <Navigate to="/settings" replace />;
}
